// extracted by mini-css-extract-plugin
export var addButton = "AddDocumentToLibraryModal-module--addButton--b9889";
export var arrow = "AddDocumentToLibraryModal-module--arrow--ef5f5";
export var arrowNo = "AddDocumentToLibraryModal-module--arrow_no--f93a0";
export var arrowYes = "AddDocumentToLibraryModal-module--arrow_yes--aaeaf";
export var checkbox = "AddDocumentToLibraryModal-module--checkbox--75cf7";
export var checkboxDescription = "AddDocumentToLibraryModal-module--checkboxDescription--d7873";
export var checkboxDescriptionSecondary = "AddDocumentToLibraryModal-module--checkboxDescriptionSecondary--18bc6";
export var contentWrapper = "AddDocumentToLibraryModal-module--contentWrapper--28930";
export var coverImage = "AddDocumentToLibraryModal-module--coverImage--55391";
export var error = "AddDocumentToLibraryModal-module--error--ba1f6";
export var flex = "AddDocumentToLibraryModal-module--flex--d3868";
export var flex1 = "AddDocumentToLibraryModal-module--flex_1--e047f";
export var flexCenter = "AddDocumentToLibraryModal-module--flex_center--bddb5";
export var flexCenterCol = "AddDocumentToLibraryModal-module--flex_center_col--319bd";
export var flexCol = "AddDocumentToLibraryModal-module--flex_col--e088d";
export var flexFixCenterCol = "AddDocumentToLibraryModal-module--flex_fix_center_col--06e61";
export var flexFixedCenterCol = "AddDocumentToLibraryModal-module--flex_fixed_center_col--4133b";
export var input = "AddDocumentToLibraryModal-module--input--bd586";
export var inputSection = "AddDocumentToLibraryModal-module--inputSection--8c9da";
export var resultText = "AddDocumentToLibraryModal-module--resultText--95d17";
export var rotating = "AddDocumentToLibraryModal-module--rotating--f126f";
export var success = "AddDocumentToLibraryModal-module--success--4d262";
export var title = "AddDocumentToLibraryModal-module--title--b59bd";
export var wrapper = "AddDocumentToLibraryModal-module--wrapper--699e4";